import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {State} from '../interfaces'
import abTest from '../slices/abTest'
import account from '../slices/account'
import agreement from '../slices/agreement'
import banner from '../slices/banner'
import cashReceipt from '../slices/cashReceipt'
import chargePoint from '../slices/chargePoint'
import common from '../slices/common'
import expenseDetails from '../slices/expenseDetails'
import fds from '../slices/fds'
import merchants from '../slices/merchants'
import modal from '../slices/modal'
import pointPayment from '../slices/pointPayment'
import priorityPaymentMethod from '../slices/priorityPaymentMethod'
import purchaser from '../slices/purchaser'
import rewardPoint from '../slices/rewardPoint'
import subscribe from '../slices/subscribe'

const createRootReducer = (): Reducer<State> =>
    combineReducers({
        abTest,
        account,
        agreement,
        banner,
        cashReceipt,
        chargePoint,
        common,
        expenseDetails,
        fds,
        merchants,
        modal,
        pointPayment,
        priorityPaymentMethod,
        purchaser,
        rewardPoint,
        router: routerReducer,
        subscribe,
    })

export default createRootReducer
